const Setting = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-cog"></i>
        <p>Setting page</p>
      </div>
    </div>
  );
};

export default Setting;
